//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      isExpand: false,
      currentStep: '01',
      steps: ['点击添加', '添加产品', '提交产品'],
      message: '点击添加',
      showindicators: false,
      loopenable: false
    }
  },
  created () {
    this.$vux.loading.hide()
  },
  methods: {
    onChange: function (index) {
      this.currentStep = '0' + (Number(index) + 1)
      this.message = this.steps[Number(index)]
    },
    leftClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2))
    },
    rightClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/createProductGuide.vue